<template>
  <div class="export-preview" aria-label="Export preview">
    <!-- Status is a small live region so screen readers announce loading/empty
         state changes WITHOUT re-reading the entire (potentially huge)
         transcript on every keystroke. -->
    <p v-if="loading" class="export-preview__empty" role="status">
      Generating preview…
    </p>
    <pre v-else-if="text" class="export-preview__text">{{ text }}</pre>
    <p v-else class="export-preview__empty" role="status">{{ emptyMessage }}</p>
    <p v-if="!loading && truncated" class="export-preview__truncated">
      Preview truncated — the exported file includes the full transcript.
    </p>
  </div>
</template>

<script>
export default {
  name: "ExportPreview",
  props: {
    text: {
      type: String,
      default: "",
    },
    truncated: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    emptyMessage: {
      type: String,
      default: "Nothing to preview yet.",
    },
  },
};
</script>

<style scoped>
.export-preview {
  background: #f7f7f8;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  padding: 16px;
  height: 100%;
  overflow-y: auto;
}

.export-preview__text {
  margin: 0;
  font-family: inherit;
  font-size: 13px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
  color: #27272a;
}

.export-preview__empty {
  color: #9ca3af;
  font-size: 13px;
}

.export-preview__truncated {
  margin-top: 12px;
  font-size: 12px;
  color: #9ca3af;
  font-style: italic;
}
</style>
